import { getAddendum } from "actions/RFQ/addendumAction";
import { AddendumClient } from "components/Pages/RFQDetail/AddendumClient";
import { useRfxData } from "newui/features/Rfx/data-provider/RfxDataProvider";
import { Rfx } from "newui/features/Rfx/types/rfx.types";
import { Addendum } from "pages/RFQSubmission/addendum/Addendum.types";
import { useEffect, useState, forwardRef } from "react";

type ClientAddendumContainerProps = {
	isCommunication: boolean;
};

export const ClientAddendumContainer = forwardRef<
	HTMLDivElement,
	ClientAddendumContainerProps
>(({ isCommunication = false }, ref) => {
	const { rfxData, hasRfxLoaded, rfxTabTotals, setRfxTabTotals } = useRfxData();
	const [addendums, setAddendums] = useState<Addendum[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const { updateLocalRfxData } = useRfxData();

	const onAddendumsUpdated = (addendums) => {
		setAddendums(addendums);
		const newCount =
			(addendums?.length ?? 0) +
			(isCommunication ? rfxTabTotals.comms : rfxTabTotals.addendums);
		setRfxTabTotals({
			...rfxTabTotals,
			addendums: isCommunication ? rfxTabTotals.addendums : newCount,
			comms: isCommunication ? newCount : rfxTabTotals.comms,
		});
	};

	useEffect(() => {
		if (!rfxData?.id || isLoading) {
			return;
		}

		setIsLoading(true);
		getAddendum(
			rfxData?.id,
			isCommunication ? "unpublished" : "published"
		).then((res) => {
			setAddendums(res?.data);

			const totalQuestions = Array.isArray(res?.data)
				? res?.data?.reduce((sum, item) => {
						return sum + (item.question?.length ?? 0);
					}, 0)
				: 0;

			updateLocalRfxData(
				isCommunication
					? ({ ...rfxData, comms_count: totalQuestions } as Rfx)
					: ({ ...rfxData, addendum_count: totalQuestions } as Rfx)
			);

			setIsLoading(false);
		});
		// eslint-disable-next-line
	}, [rfxData?.id, isCommunication]);

	return (
		<div ref={ref}>
			{
				// @ts-ignore
				<AddendumClient
					rfqDetail={rfxData}
					addendumData={addendums}
					setAddendumData={onAddendumsUpdated}
					isCommunication={isCommunication}
					isDataLoading={isLoading || !hasRfxLoaded}
				/>
			}
		</div>
	);
});
